import {
  PaymentMethodsState,
  SetCardsAction,
  RemoveCardAction,
  SetActiveCardAction,
} from './interface';
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '$store/rootReducer';

const initialState: PaymentMethodsState = {
  isLoading: true,
  isChangeCard: true,
  cards: [],
};

export const { actions, reducer } = createSlice({
  name: 'paymentMethods',
  initialState,
  reducers: {
    loadCards(state) {
      state.isLoading = true;
    },

    setCards(state, action: SetCardsAction) {
      state.cards = action.payload;
      state.isLoading = false;
      state.isChangeCard = false;
    },

    setActiveCards(state, _: SetActiveCardAction) {
      state.isChangeCard = true;
    },

    removeCard(state, _: RemoveCardAction) {},

    clear(state) {
      state.isLoading = initialState.isLoading;
      state.isChangeCard = initialState.isChangeCard;
    },
  },
});

export { reducer as paymentMethodsReducer, actions as paymentMethodsActions };
export const paymentMethodsSelector = (state: RootState) => state.paymentMethods;
